
import { IRutinInfo } from '../../../../Types/RutinInfoType';
import {
  useBusinessCollectionMenuItemsType,
  useItemFunctionMenuItemsType,
} from '../../../../Utils/ObjektVyUtils';
import {
  createStandardRutin,
  IStandardRutinWrapperProps,
} from '../../_StandardRutin/StandardRutin';

export const getStandardRutin = (
  rutinInfo: IRutinInfo,
  businessCollectionName: string,
  useItemFunctionMenuItems?: useItemFunctionMenuItemsType,
  useBusinessCollectionMenuItems?: useBusinessCollectionMenuItemsType,
  standardRutinWrapper?: React.ComponentType<
    React.PropsWithChildren<IStandardRutinWrapperProps>
  >
) =>
  createStandardRutin(
    rutinInfo,
    businessCollectionName,
    useItemFunctionMenuItems,
    useBusinessCollectionMenuItems,
    standardRutinWrapper
  );

export default getStandardRutin;
